var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('el-button',{attrs:{"type":"primary","size":"default","loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" 快照 ")]),_c('p',[_vm._v(" 本接口较慢（大于1分钟，5分钟内），且后端限制24小时内仅能调用一次，请不要刷新和重复点击快照 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }